import { useCompareOffersStore } from '.';

export function useIsOfferSelectedForCompare(offerId: string) {
  return useCompareOffersStore(state =>
    state.selectedOffers.some(offer => offer.marketplaceEntity.id === offerId),
  );
}

export function useCanSelectOfferForCompare(offerId: string) {
  return useCompareOffersStore(
    state =>
      state.selectedOffers.some(offer => offer.marketplaceEntity.id === offerId) ||
      state.selectedOffers.length < state.maxSelectedOffers,
  );
}
